export default __webpack_public_path__ + "static/media/goal_DE.bbe9267f.png";